module.exports = "<div id=\"{{id}}\" [style.display]=\"'inline-block'\">\n  <i #tooltip class=\"{{ config.fontAwesomeStyle || 'fa' }} {{config.icon}}\"\n    [class.background]=\"config.hoverStyle == 'background'\"\n    [class.cast-shadow]=\"config.hoverStyle == 'cast-shadow'\"\n    aria-hidden=\"true\" data-toggle=\"popover\"></i>\n  <div #content [style.display]=\"'none'\">\n    <ng-content></ng-content>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/smart-tooltip/smart-tooltip.component.html
// module id = ./src/app/shared/components/smart-tooltip/smart-tooltip.component.html
// module chunks = main